
/** 
	modes obtained by adding classes
*/

import WDElement from '../wd-element';
import WDAccordionCard from './wd-accordion-card';

export default class WDAccordion extends WDElement
{

	#options = {
		mode: 'multiple',
		sortable: false
	};

	#sortable = null;

	constructor(opts)
	{
		super().classList.add('wd-accordion');
		if (opts) Object.assign(this.#options, opts);

		if (!this.#options.mode) this.#options.mode = 'multiple';

		return this;
	};

	disconnectedCallback()
	{
		super.disconnectedCallback();
		this.offAll();

		if (this.#sortable)
		{
			this.#sortable.destroy();
			this.#sortable = null;
		}
	};

	addSortable()
	{
		import('sortable').then(module =>
		{

			this.#sortable = module.Sortable.create(this, {
				handle: '.handle',
				dataIdAttr: 'id',
				onEnd: (evt) => this.trigger('accordion:sort', this),
			});

		});
	};

	//readonly link to panels
	get items() { return this.children; };
	get options() { return this.#options; };
	get sortValue() { return this.#sortable.toArray() };

	/**
		reset the accordion back
		*/
	reset()
	{
		this.empty();
	};

	push(toggle)
	{
		//build the pane and save
		const card = new WDAccordionCard(toggle);
		this.add(card);

		return card;
	};

	add(card)
	{
		if (this.#options.mode == 'single')
		{
			card.on('accordion:show', () => this.items.forEach( c => c.hide() ));
		}

		this.append(card);

		if (this.#options.sortable == true) this.addSortable();
	};

	insertAt(idx, toggle)
	{
		const card = new WDAccordionCard(toggle);

		if (idx == '0')
		{
			this.prepend(card);
		}
		else if (idx >= this.items.length - 1)
		{
			this.append(card);
		}
		else
		{
			card.insertBefore(this.items[idx]);
		}

		if (this.#options.sortable == true) this.sortable();

		return card;
	};

	handleCardRemoved(evt, card)
	{
	};

	showAll()
	{
		this.items.forEach((p) => p.show());
	};

	hideAll()
	{
		this.items.forEach((p) => p.hide());
	};

	toggleAll()
	{
		let visible = 0;

		this.items.forEach((p) =>
		{
			if (!p.collapsed) visible++;
		});

		if (visible >= this.items.length / 2) this.hideAll();
		else this.showAll();

	};

	/** visibility methods **/
	showCard(idx) { this.items[idx].show(); };
	hideCard(idx) { this.items[idx].hide(); };
	toggleCard(idx) { this.items[idx].toggle(); };
	cardAtIndex(idx) { return this.items[idx]; };

};

customElements.define('wd-accordion', WDAccordion);
